import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {ListItemSecondaryText as RmwcListItemSecondaryText} from '@rmwc/list'
import '@rmwc/list/styles'

const theme = ({theme}) => css`
  .mdc-theme--on-${theme} &&& {
    color: var(--mdc-theme-neutral3);
  }
`

const StyledRmwcListItemSecondaryText = styled(RmwcListItemSecondaryText)`
  &&& {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 12px;
  }
  ${theme({theme: 'primary'})};
`

const ListItemSecondaryText = ({children, ...otherProps}) => <StyledRmwcListItemSecondaryText {...otherProps}>{children}</StyledRmwcListItemSecondaryText>

ListItemSecondaryText.propTypes = {
  children: PropTypes.any
}

export {ListItemSecondaryText}
